import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {DocumentsKeyEnum} from "@brightside-web/shared/legal-documents";

@Component({
    selector: 'brightside-web-loans-legal-docs',
    templateUrl: './loans-legal-docs.component.html',
    styleUrls: ['./loans-legal-docs.component.css'],
    standalone: false
})
export class LoansLegalDocsComponent {

  documentsKey: DocumentsKeyEnum

  constructor(
    private router: Router
  ) {
    const state = this.router.currentNavigation()?.extras.state;
    if (state && state.documentsKey) {
      this.documentsKey = state.documentsKey as DocumentsKeyEnum;
    } else {
      this.router.navigate(['home']);
    }
  }

  termsAccepted($event: boolean) {
    this.router.navigate(['accounts','loans', 'info']);
  }

  goToHome() {
    this.router.navigate(['home']);
  }
}
